import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Modal,Select  } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';


const { Panel } = Collapse;
const { Search } = Input;
const buttonWidth = 70;
const { Option } = Select;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			school_list : [],
			loading: false,
			visible: false,
			select_id : '',
			status : '',
		}
		
		this.emailshare = this.emailshare.bind(this);
		this.smsshare = this.smsshare.bind(this);
		this.whatsapp_redirect = this.whatsapp_redirect.bind(this);
		this.change_status = this.change_status.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 school_id : storedArray['data'][0]['school_id'], 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var status = this.state.status;
			
			var app = {user_id : user_id,school_id:school_id,status:status}
			getData('erp/invite_parents_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
						});
					}
				}
			});	
		}
	  }
	
	hide = () => {
    this.setState({
      visible: false,
    });
  };
  
  handleVisibleChange = visible => {
    this.setState({ visible });
  };
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  showModal = (id,e,a) => {
   
    this.setState({
      visible: true,
      select_id: id,
      student_id: e,
      mobile: a,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };
    
  emailshare =(e)=> {
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				select_id: this.state.select_id,
				school_id: this.state.school_id,
				user_id: this.state.user_id,
				student_id: this.state.student_id,
			}
			getData('erp/invite_via_email',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Invite Shared',2);
					this.setState({ visible: false,});
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
  smsshare =(e)=> {
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				select_id: this.state.select_id,
				school_id: this.state.school_id,
				user_id: this.state.user_id,
				student_id: this.state.student_id,
			}
			getData('erp/invite_via_sms',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Invite Shared',2);
					this.setState({ visible: false,});
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	whatsapp_redirect(){ 
		
		
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				select_id: this.state.select_id,
				school_id: this.state.school_id,
				user_id: this.state.user_id,
				student_id: this.state.student_id,
			}
			getData('erp/invite_text',app).then((result) => {
				
				if(result.status==200){
					var msg = result.message_user
					var link = 'https://api.whatsapp.com/send?phone=+91'+this.state.mobile+'&text='+msg ;
					window.open(link, '_blank');
					this.setState({ visible: false });
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
		
	}
	
	change_status(event){
         this.setState({status: event});
		 setTimeout(() => {
			this.checkData();
		}, 50);
     }

	render()

	{
	
	const { size } = this.state;
	  const { visible, loading } = this.state;			
	  const student_lenght = this.state.school_list.length;			
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Invite Parents</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Invite Parents
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
             
		 
		 
		<div class="col m3 s12 mb-10 ex-padd right view-Profile view-Profile-mobile center">
				<Select onChange={this.change_status} defaultValue="All">
						<Select.Option value="" >All</Select.Option>
						<Select.Option value="1">Active</Select.Option>
						<Select.Option value="0">Inactive</Select.Option>
				</Select>
		</div>	
           
          
		<div class="col s12 m12 ex-padd">  
            <div class="container view-Profile viewprograms view-Profile-mobile ">
			   <div class="col s12 m12 mb-20 card-content iq-card mh-500">
                  <section class="invoice-list-wrapper section food ">
					
					
					
					{this.state.school_list.map((list)=> (
					<div class="children bg-blue communication mb-20 pb-20 iq-card2 bg-color-6 ">
                     <Collapse defaultActiveKey={list.program_id} classname="as" onChange={callback}>
						<Panel header={list.program_name}  key={list.program_id}>
							<div class="children bg-blue attendance">
								<div class="col m8 s12 mb-10">
									<label class="m-r-5 mobile-block">Toatal Student : <b>{list.total_student}</b></label>
									<label class="m-r-5 mobile-block">Active Student : <b>{list.active_student}</b></label>
									<label class="m-r-5 mobile-block">Inactive Student : <b>{list.inactive_student}</b></label>
									
								</div>
								 <div class="col m4 s12 mb-10 right">
									
									<Search placeholder="Search (Parent, Child Name, Phone , Email)" className="" onSearch={value => console.log(value)}  />
								</div> 
								{list.student.map((student) =>(
								<div class="col m12 s12 mb-10 center no-padd mt-10 width-etra">
									<div class="shadow">
									<div class="col m12 s12 pb-5">
									{(() => {
												if (student.profile_pic != '') {
													return (
														<img src={student.profile_pic} class="atd-img user-profile-pic" /> 
													)
												}else{
													return (
														<img src={person} class="atd-img" /> 
													)
												}
											})()}<span class="title-font">{student.student_name}</span> </div>
									{student.parent.map((parent)=>(
									<>
									<div class="col m12 s12 bt pt-5 pb-5">
										<div class="col m10 s9 no-padd">
											<div class="col m6 s12 t-left mt-10 no-padd">
												<label>Relation </label> : <span>{parent.parent_relation}</span>
											</div>
											<div class="col m6 s12 t-left mt-10 no-padd">
												<label>Name </label> : <span>{parent.parent_name}</span>
											</div>
											<div class="col m6 s12 t-left mt-10 no-padd">
												<label>Mobile </label> : <span>{parent.parent_mobile}</span>
											</div>
											<div class="col m6 s12 t-left mt-10 no-padd">
												<label>Email </label> : <span>{parent.parent_email}</span>
											</div>
											
										</div>
										<div class="col m2 s3 pt-10">
											<Button className="snd-btn"  onClick={this.showModal.bind(this,parent.parent_id,student.student_id,parent.parent_mobile)}>Invite</Button>
										</div>
									</div>
									</>
									))}
									</div>
									{(() => {
										if (list.student.lenght == 0) {
										return (
												<h6 class="center">No Student Found</h6>
											   )
										}
									})()}
								</div> 
								))}	
							
							</div>	
							
						</Panel>
					  </Collapse>
					</div>				
					
					))}
					
					<Modal
										  visible={visible}
										  title="Title"
										  className="invite"
										  onOk={this.handleOk}
										  onCancel={this.handleCancel}
										  footer={[
											
										  ]}
										>
										  <p class="title">Invite Via</p>
										  
										  <p onClick={this.emailshare}>Email</p>
										  <p onClick={this.whatsapp_redirect}>Whatsapp</p>
										  <p onClick={this.smsshare}>SMS</p>
										</Modal> 
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
